import React from "react";
import PinSvg from "../assets/icons/pin_filled.svg";
import PinFullSvg from "../assets/icons/pin_filled_cinza2.svg";
import { Tooltip } from 'reactstrap';

function AreaBookmark({ active, onChange, text, top, layout, refresh }) {
	const [tooltipOpen, setTooltipOpen] = React.useState(false);
	const toggle = () => setTooltipOpen(!tooltipOpen);
	const ref = React.createRef();

	return (
		<>
		<a href="#" ref={ref} className="tooltip-custom"  style={{position: 'absolute', right: '0', paddingRight: layout ? '1px' : '3px', paddingLeft: layout ? '1px' : '3px', 
						display: 'block', fontSize: '1.1em', color: (true ? '#E78E4B' : '#a74040'), height: layout ? '10px' : 'auto',
						background: 'white', borderLeft: '1px solid #d3d3d3', borderBottom: '1px solid #d3d3d3',
						borderRadius: '0 0 0 4px', zIndex: '1'
					}} onClick={(e) => { 
						e.preventDefault(); 
						e.bubbles = false;
						onChange(e); 
					}}>
				<img  style={{ width: layout ? '10px' : '16px', height: layout ? '10px' : '16px', top: layout ? '-10px' : 'auto', position: 'relative'}} src={ (active ? PinSvg : PinFullSvg) } />
		</a>
		<Tooltip
			placement="top"
			isOpen={tooltipOpen}
			autohide={false}
			target={ref}
			toggle={toggle}
		>
			<span style={{ fontSize: '14px'}}>
			{ text?? 'Mark as default' }
			</span>
		</Tooltip>
		</>
	);
}

export default AreaBookmark;
